<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{
                  cid.id ? $t("cid.form.titleEdit") : $t("cid.form.titleNew")
                }}
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span>
                        {{ $t("cid.form.codeLabel") }}
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="cid.code"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span>
                        {{ $t("cid.form.nameLabel") }}
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="cid.name"
                        placeholder=""
                      />
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span>
                        {{ $t("cid.form.statusLabel") }}
                      </label>
                      <select v-model="cid.status" class="form-control">
                        <option :value="1">{{ $t("common.active") }}</option>
                        <option :value="0">{{ $t("common.inactive") }}</option>
                      </select>
                    </div>
                    <div class="form-group col-md-6" style="margin-top: 10px">
                      <div class="custom-control custom-switch pt-2">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="mandatoryNotification"
                          v-model="cid.mandatory_notification"
                        />
                        <label
                          class="custom-control-label"
                          for="mandatoryNotification"
                        >
                          {{ $t("cid.form.mandatoryNotificationLabel") }}
                        </label>
                      </div>
                    </div>
                  </div>

                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>{{ $t("cid.form.requiredFields") }}</strong>
                  </span>
                  <div class="block text-right">
                    <router-link to="/cids" class="btn btn-back mr-1">
                      <i class="fa fa-arrow-left"></i> {{ $t("common.back") }}
                    </router-link>
                    <a
                      v-if="$hasAbility('cadastro.gerenciar')"
                      class="btn btn-add"
                      @click="save"
                    >
                      {{ $t("common.save") }}
                      <i class="fa fa-save"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";

export default {
  data() {
    return {
      cid: {
        code: "",
        name: "",
        status: "1",
        mandatory_notification: false,
      },
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "cids";

      if (self.cid.id) {
        self.cid._method = "PUT";
        api += "/" + self.cid.id;
      }

      self.$loading(true);

      axios
        .post(api, self.cid)
        .then((response) => {
          self.$message(
            self.$t("cid.messages.saveSuccessTitle"),
            self.$t("cid.messages.saveSuccessMessage"),
            "success"
          );
          self.$loading(false);
          this.$router.push("/cids");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getCid: function (id) {
      const self = this;
      const api = self.$store.state.api + "cids/" + id;
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.cid = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    let id = self.$route.params.id;
    if (id) {
      self.getCid(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    Loading,
  },
};
</script>
<style scoped>
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 255, 128, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>